import { sortByTitle } from '../../data_management/sorters/sort_by_title';

class QuestionAnalysis {

  constructor($scope, dataService, analysisGateway) {
    this.$scope = $scope;
    this.dataService = dataService;
    this.analysisGateway = analysisGateway;
    this.questionnaires = [];
    this.versions = [];
    this.sections = [];
    this.questions = [];
    this.currentQuestionnaireIndex = 0;
    this.currentVersionIndex = 0;
    this.currentSectionIndex = 0;
    this.currentQuestionIndex = 0;
  }

  $onChanges() {
    // console.log("Retrieve data for workspace", this.workspace);
    if (this.workspace) this.retrieveQuestionnaires();
  }

  retrieveQuestionnaires() {
    return this.analysisGateway.questionnairesSentToWorkspace(this.dataService.secretKey, this.workspace.id)
      .then(data => {
        this.questionnaires = data;
        this.questionnaires.sort(sortByTitle);
        console.log("Questionnaires", data);
        this.$scope.$digest();
      })
      .then(() => this.retrieveVersions());
  }

  retrieveVersions() {
    return this.analysisGateway.versionsSentToWorkspace(this.dataService.secretKey, this.workspace.id, this.questionnaire.id)
      .then(data => {
        this.versions = data;
        console.log("Versions", data);
        this.$scope.$digest();
      })
      .then(() => this.retrieveSections());
  }

  retrieveSections() {
    return this.analysisGateway.sectionsSentToWorkspace(this.dataService.secretKey, this.workspace.id, this.questionnaire.id, this.version.id)
      .then(data => {
        this.sections = data;
        console.log("Sections", data);
        this.$scope.$digest();
      })
      .then(() => this.retrieveQuestions());
  }

  retrieveQuestions() {
    return this.analysisGateway.questionsSentToWorkspace(this.dataService.secretKey, this.workspace.id, this.questionnaire.id, this.version.id, this.section.id)
      .then(data => {
        this.questions = data;
        console.log("Questions", data);
        this.$scope.$digest();
      });
  }

  get questionnaire() {
    return this.questionnaires[ this.currentQuestionnaireIndex ];
  }

  get version() {
    return this.versions[ this.currentVersionIndex ];
  }

  get section() {
    return this.sections[ this.currentSectionIndex ];
  }

  get question() {
    return this.questions[ this.currentQuestionIndex ];
  }

  navToPreviousQuestionnaire() {
    if (this.currentQuestionnaireIndex === 0) this.currentQuestionnaireIndex = this.questionnaires.length;
    this.currentQuestionnaireIndex--;
    return this.retrieveVersions();
  }

  navToNextQuestionnaire() {
    if (this.currentQuestionnaireIndex === this.questionnaires.length - 1) this.currentQuestionnaireIndex = -1;
    this.currentQuestionnaireIndex++;
    return this.retrieveVersions();
  }

  navToPreviousVersion() {
    if (this.currentVersionIndex === 0) this.currentVersionIndex = this.versions.length;
    this.currentVersionIndex--;
    return this.retrieveSections();
  }

  navToNextVersion() {
    if (this.currentVersionIndex === this.versions.length - 1) this.currentVersionIndex = -1;
    this.currentVersionIndex++;
    return this.retrieveSections();
  }

  navToPreviousSection() {
    if (this.currentSectionIndex === 0) this.currentSectionIndex = this.sections.length;
    this.currentSectionIndex--;
    return this.retrieveQuestions();
  }

  navToNextSection() {
    if (this.currentSectionIndex === this.sections.length - 1) this.currentSectionIndex = -1;
    this.currentSectionIndex++;
    return this.retrieveQuestions();
  }

  navToPreviousQuestion() {
    if (this.currentQuestionIndex === 0) this.currentQuestionIndex = this.questions.length;
    this.currentQuestionIndex--;
    return this.retrieveQuestions();
  }

  navToNextQuestion() {
    if (this.currentQuestionIndex === this.questions.length - 1) this.currentQuestionIndex = -1;
    this.currentQuestionIndex++;
    return this.retrieveQuestions();
  }

}

export default {
  name: 'questionAnalysis',
  obj: {
    controller: QuestionAnalysis,
    bindings: {
      workspace: '<'
    },
    template: `
        <header class="component">
            <h2>Response Analyses</h2>
        </header>
        
        <section class="selector">
            <section class="questionnaire">
              <action-button busy-text="''" action="$ctrl.navToPreviousQuestionnaire()" icon="ic_arrow_back"></action-button>
                  {{ $ctrl.questionnaire.title }}
              <action-button busy-text="''" action="$ctrl.navToNextQuestionnaire()" icon="ic_arrow_forward"></action-button>
            </section>
            <section class="version">
              <action-button busy-text="''" action="$ctrl.navToPreviousVersion()" icon="ic_arrow_back"></action-button>
                  Version {{ $ctrl.version.number }}
              <action-button busy-text="''" action="$ctrl.navToNextVersion()" icon="ic_arrow_forward"></action-button>
            </section>
            <section class="section">
              <action-button busy-text="''" action="$ctrl.navToPreviousSection()" icon="ic_arrow_back"></action-button>
                  {{ $ctrl.section.title }}
              <action-button busy-text="''" action="$ctrl.navToNextSection()" icon="ic_arrow_forward"></action-button>
            </section>
            <section class="question">
              <action-button busy-text="''" action="$ctrl.navToPreviousQuestion()" icon="ic_arrow_back"></action-button>
              <span ng-bind-html="$ctrl.question.content | trust"></span>
              <action-button busy-text="''" action="$ctrl.navToNextQuestion()" icon="ic_arrow_forward"></action-button>
            </section>
        </section>
    `
  }
}